import { BrowserRouter, Routes, Route } from "react-router-dom";
import Loginsuccess from './components/Loginsuccess/Loginsuccess.component';
import Login from './components/Login/Login.component';
import CheckoutSuccess from './components/CheckoutSuccess/CheckoutSuccess.component';
import PaymentDeclined from './components/CheckoutFailed/CheckoutFailed';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<Loginsuccess />} > */}
          <Route path="loginsuccess" element={<Loginsuccess />} />
          <Route path="login" element={<Login />} />
          <Route path="checkoutsuccess" element={<CheckoutSuccess />}/>
          <Route path="PaymentDeclined" element={<PaymentDeclined />}/>
        {/* </Route> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
